import { render, staticRenderFns } from "./memberConfig.vue?vue&type=template&id=57c282d1&scoped=true&"
import script from "./memberConfig.vue?vue&type=script&lang=js&"
export * from "./memberConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c282d1",
  null
  
)

export default component.exports